import type { Entity } from "../types";

/**
 * Disponibilidade por empresa ou por projeto. Baixar o cadastro em uma empresa (ou em um projeto) não afeta as demais:
 * cada uma tem a sua própria situação (ativo/baixado). A sequência de vistorias também é contada por empresa.
 */
export function VehicleAvailabilityPanel({ companies, selectedIds, inactiveIds, onChange, subject = "veículo", scope = "empresa" }: { companies: Entity[]; selectedIds: string[]; inactiveIds: string[]; onChange: (inactiveIds: string[]) => void; subject?: "veículo" | "motorista"; scope?: "empresa" | "projeto" }) {
  if (!selectedIds.length) return null;
  const nameOf = (id: string) => {
    const item = companies.find((candidate) => candidate.id === id);
    return String(item?.tradeName || item?.legalName || item?.name || item?.code || id);
  };
  const toggle = (id: string, active: boolean) => onChange(active ? inactiveIds.filter((item) => item !== id) : [...new Set([...inactiveIds, id])]);
  return <fieldset className="vehicle-availability field-full">
    <legend>Disponibilidade por {scope}</legend>
    <p>Desmarque {scope === "projeto" ? "o projeto" : "a empresa"} em que o {subject} foi <strong>baixado</strong>. {scope === "projeto" ? "Os demais projetos não são afetados." : "As demais empresas não são afetadas."}</p>
    <div className="vehicle-availability-list">
      {selectedIds.map((id) => {
        const active = !inactiveIds.includes(id);
        return <label key={id} className={active ? "" : "is-inactive"}>
          <input type="checkbox" checked={active} onChange={(event) => toggle(id, event.target.checked)}/>
          <span>{active ? "Ativo em" : "Baixado em"} <strong>{nameOf(id)}</strong></span>
        </label>;
      })}
    </div>
  </fieldset>;
}
